interface MoneyFormatOptions {
	forceFractionDigits?: boolean;
}

export const formatMoney = (value: number, config: MoneyFormatOptions = {}): string => {
	const { forceFractionDigits = false } = config;

	const fractionDigits = forceFractionDigits ? 2 : Number.isInteger(value) ? 0 : 2;

	const c = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits
	});

	return c.format(value);
};

export function inDollars(centAmount: number = 0): number {
	return centAmount * 0.01;
}
